import styled from 'styled-components';
import { vars } from '../../../theme';
import spacing from '../../../styles/spacing';

// Row container for all badges - scrolls with columns
export const BadgeRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    margin-bottom: ${spacing[8]};
`;

// Slot that spans the width of a group's columns
// Contains the sticky badge inside
export const GroupSlot = styled.div<{
    $width: number;
}>`
    display: flex;
    flex-shrink: 0;
    width: ${props => props.$width}px;
    min-width: ${props => props.$width}px;
`;

export const TextColorWrapper = styled.span<{
    $textColor: string;
}>`
    color: ${props => props.$textColor};
`;
// The actual badge that becomes sticky
export const StickyBadge = styled.div<{
    $backgroundColor: string;
    $borderColor: string;
    $horizontalPadding?: number;
}>`
    position: sticky;
    margin-right: ${spacing[8]};
    left: ${props => props.$horizontalPadding ?? 0}px;
    z-index: 10;
    display: inline-flex;
    align-items: center;
    padding: 1px 5px;
    gap: 6px;
    background-color: ${props => props.$backgroundColor};
    border: 1px solid ${props => props.$borderColor};
    border-radius: ${vars.radius.md} ${vars.radius.xs} ${vars.radius.xs}
        ${vars.radius.xs};
    white-space: nowrap;
`;
